export const calculateAgeAtExamDate = (
    dateOfBirth: string | Date,
    referenceDate: string | Date = new Date(),
) => {
    if (!dateOfBirth) return null;

    const birth = new Date(dateOfBirth);
    const reference = new Date(referenceDate);

    let years = reference.getFullYear() - birth.getFullYear();
    let months = reference.getMonth() - birth.getMonth();
    let days = reference.getDate() - birth.getDate();

    if (days < 0) {
        months--;
        const prevMonth = new Date(reference.getFullYear(), reference.getMonth(), 0);
        days += prevMonth.getDate();
    }

    if (months < 0) {
        years--;
        months += 12;
    }

    return { years, months, days };
};
